type SelectorMap = SelectorNode | SelectorLeaf;
type SelectorNode = { [key: string]: SelectorMap | SelectorLeaf };
type SelectorLeaf = string;

/**
 * Selectors going forward.
 */
const selectorMap = {
  appLayout: {
    rightSide: '',
  },
  /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
  community: {
    documents: {
      card: '',
    },
    /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
    index: {
      documentsTab: '',
      /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
      workflowsTab: '',
    },
    /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
    workflows: {
      /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
      card: {
        /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
        detail: '',
        /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
        importButton: '',
        /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
        viewImportedButton: '',
      },
      /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
      detail: {
        /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
        importButton: '',
        /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
        importSuccessSnack: '',
      },
      importedCard: '',
      nonImportedCard: '',
    },
  },

  components: {
    accountsAutocomplete: {
      accountOption: '',
      listBox: '',
    },
    accountsRolesAutocomplete: {
      clearXButton: '',
    },
    addCollaboratorsDialog: {
      accountsAutocomplete: '',
      submitButton: '',
    },
    answerOptionsAutocomplete: {
      answerOptionsAutocompleteInput: '',
    },
    assigneesAutocomplete: {
      labelOption: '',
      listBox: '',
    },

    collaboratorsAutocomplete: {
      addCollaboratorButton: '',
      collaboratorOption: '',
      listBox: '',
    },

    fieldRecipientsAutocomplete: {
      addRecipientButton: '',
      autocomplete: '',
      clearXButton: '',
      listBox: '',
      recipientSignerOption: '',
    },

    filters: {
      button: '',
    },

    labelsAutocomplete: {
      labelOption: '',
      listBox: '',
    },

    quickStart: {
      button: {
        continue: '',
      },
      steps: {
        inviteReviewers: '',
        saveAsDraft: '',
        sendForSignature: '',
      },
    },

    workflowAssignmentAutocomplete: {
      addCollaboratorButton: '',
      collaboratorOption: '',
      listBox: '',
    },
  },
  dialog: {
    alineDialog: {
      closeButton: '',
    },
    newContractDialog: {
      contractNameInput: '',
      submitButton: '',
      workflowNameInput: '',
    },
    signatureDialog: {
      closeXButton: '',
      typedInitialsCanvas: '',
      typedInitialsImg: '',
      typedInitialsInput: '',
      typedSignatureCanvas: '',
      typedSignatureImg: '',
      typedSignatureInput: '',
    },
    submitButton: '',
  },
  /** Ne touchez pas! Used in Intercom Tour. */
  document: {
    addContentButton: '',
    /** Ne touchez pas! Used in Intercom Tour. */
    addWorkFlowFilesButton: '',
    alert: {
      contractAlert: '',
    },
    chatButton: '',
    commentsButton: '',
    debugOverlay: {
      paragraph: '',
      signatureField: '',
      signedSignatureField: '',
    },
    documentSummaryButton: {
      panel: {
        container: '',
      },
    },
    editor: {
      appBar: {
        contractType: '',
        convertToAline: {
          button: '',
        },
        nameWorkflowInput: '',
        syncStatus: '',
      },
      pageContent: '',
      popper: {
        aiAssistant: {
          cancelCompletionButton: '',
          completion: {
            copyButton: '',
            text: '',
          },
          discardButton: '',
          input: '',
          insertTextButton: '',
          main: '',
          moreButton: '',
          moreList: {
            fixSpellingButton: '',
            improveLanguageButton: '',
            insertAboveButton: '',
            insertBelowButton: '',
            makeLongerButton: '',
            makeShorterButton: '',
            retryButton: '',
            simplifyButton: '',
            suggestNegotiationButton: '',
            summarizeButton: '',
          },
          submitButton: '',
        },
        signHere: {
          signButton: '',
        },
      },
      reactWindow: '',
      rightDrawer: {
        addContentPanel: {
          addCheckboxFieldButton: '',
          addDateFieldButton: '',
          addDropdownDCMenuItem: '',
          addDropdownFieldButton: '',
          addDynamicBlockButton: '',
          addInitialsButton: '',
          addNumberFieldButton: '',
          addRadioDCMenuItem: '',
          addRadioFieldButton: '',
          addSavedFieldButton: '',
          addSignatureButton: '',
          addTextFieldButton: '',
          container: '',
          dragCannedAddressButton: '',
          dragCannedCompanyButton: '',
          dragCannedDateSignedButton: '',
          dragCannedUserEmailButton: '',
          dragCannedUserNameButton: '',
          dragCannedUserTitleButton: '',
          dragDateFieldButton: '',
          dragDropdownFieldButton: '',
          dragDynamicBlockButton: '',
          dragInitialsButton: '',
          dragNumberFieldButton: '',
          dragRadioFieldButton: '',
          dragSavedFieldButton: '',
          dragSignatureButton: '',
          dragTextFieldButton: '',
        },
        /** Ne touchez pas! Used in ExampleNDA - Playbook Intercom Tour. */
        ai: {
          panel: {
            addPlaybookButton: '',
            autoGenerateButton: '',
            playbookCard: {
              container: '',
              exampleNDAContainer: '',
            },
            playbookDetail: {
              runAllButton: '',
            },
            playbookList: '',
            playbooksTab: '',
            ruleCard: {
              container: '',
            },
          },
          /** Ne touchez pas! Used in ExampleNDA - Playbook Intercom Tour. */
          panelButton: '',
        },
        comments: {
          commentBoxCard: {
            container: '',
            content: '',
            subheader: '',
          },
          commentInput: '',
          replyInput: '',
        },
        documentSummaryButton: {
          panel: {
            container: '',
          },
        },
        editSignaturePanel: {
          container: '',
        },
        editVariablePanel: {
          container: '',
        },
        extraction: {
          panel: {
            addQuestionButton: '',
            newQuestionCard: {
              container: '',
            },
            questionCard: {
              container: '',
            },
            questionList: '',
            runAllButton: '',
          },
          panelButton: '',
        },
        fieldDetailPanel: {
          addOptionButton: '',
          answerOptionInput: '',
          assignAutocomplete: '',
          container: '',
          defaultAnswerSelect: '',
          defaultAnswerSelectItem: '',
          labelInput: '',
          questionInput: '',
          toggleMultilineButton: '',
        },
        goBackButton: '',
        outline: {
          cannedFieldRowInput: '',
          container: '',
          dateFieldRowInput: '',
          dropDownFieldRowInput: '',
          numberFieldRowInput: '',
          radioFieldRowInput: '',
          radioOptionsButton: '',
          textFieldRowInput: '',
          variableRow: {
            deleteMenuItem: '',
            editButton: '',
            editMenuItem: '',
          },
        },
        signatureDetailPanel: {
          assignAutocomplete: '',
        },
        spellcheck: {
          container: '',
          problemRow: '',
          status: '',
        },
        variable: {
          list: {
            container: '',
            empty: '',
            row: {
              container: '',
              header: '',
              label: '',
            },
          },
        },
      },
      spellcheckPopover: {
        container: '',
      },
      versionHistory: {
        container: '',
        layoutEngine: '',
      },
      walkthrough: {
        advanceWalkthroughButton: '',
        doneSigningPage: '',
        downloadButton: '',
        finishLaterButton: '',
        finishSigningButton: '',
        mobile: {
          signaturePreviewBody: '',
        },
        overflowMenuButton: '',
        reassignedPage: '',
        startWalkthroughButton: '',
      },
      wordProcessor: '',
    },
    fields: {
      dragHandle: '',
      dragInPageOverlay: '',
      dragOutsidePageOverlay: '',
      dragPreview: '',
      inputFieldEl: '',
      signedSignatureEl: '',
    },
    leftOutline: {
      closeOutlineButton: '',
      fileCard: '',
      openOutlineButton: '',
    },

    newDocumentButton: '',
    /** Ne touchez pas! Used in Intercom Tour. */
    outlineButton: '',
    partiesButton: '',
    s4s: {
      bottomBar: {
        continueButton: '',
        sanityCheck: {
          missingActions: { cancelButton: '', container: '', nextButton: '' },
          success: { cancelButton: '', container: '', nextButton: '' },
          unassignedRoles: { cancelButton: '', container: '', nextButton: '' },
          unusedActions: { cancelButton: '', container: '', nextButton: '' },
        },
      },
    },
    sendDocument: {
      button: '',
      sendForSignMenuItem: '',
    },
    spellcheckButton: '',
    staticViewer: {
      loadingViewerProgressBar: '',
      removeAnnotationsSnack: '',
      viewerEl: '',
    },
    trackedChangesButton: '',
  },

  globalTopBar: {
    aiChatToggle: '',
    loggedInAvatar: '',
    notificationsButton: '',
    notificationsPopper: '',
  },

  /** Ne touchez pas! Used in Intercom Tour. */
  leftNav: {
    admin: {
      billing: { tab: '' },
      groups: { tab: '' },
      icon: '',
      integrations: { docuSign: { integratedButton: '', setupButton: '' }, tab: '' },
      org: { tab: '' },
      users: { tab: '' },
    },
    aiChat: { icon: '' },
    /** Ne touchez pas! Used in Intercom Tour. */
    community: { icon: '' },
    dashboard: { icon: '' },
    drawer: '',
    entrypoint: {
      createDocumentButton: '',
      createNewButton: '',
      newTemplateButton: '',
      newWorkflowButton: '',
    },
    /** Ne touchez pas! Used in Intercom Tour. */
    getStarted: { icon: '' },
    identifiers: { icon: '' },
    insights: { icon: '' },
    parties: { icon: '' },
    playbooks: { icon: '' },
    reminders: { icon: '' },
    reports: { icon: '' },
    repository: { icon: '' },
    templates: { icon: '' },
    variables: { icon: '' },
    workflows: { icon: '' },
  },

  playbooks: {
    addCategory: '',
    addCategoryHeader: '',
    addPosition: '',
    addPositionHeader: '',
    addRule: '',
    categoryCard: '',
    categoryDelete: '',
    categoryDeleteConfirm: '',
    categoryDragHandle: '',
    categoryEmpty: '',
    categoryName: '',
    columnDivider: '',
    deleteButton: '',
    description: '',
    detailBack: '',
    detailDelete: '',
    detailPage: '',
    detailTitle: '',
    duplicateButton: '',
    editWithAiButton: '',
    emptyState: '',
    nameCell: '',
    newPlaybookButton: '',
    positionCard: '',
    positionDelete: '',
    positionDeleteConfirm: '',
    positionEdit: '',
    positionGuidance: '',
    positionText: '',
    ruleDelete: '',
    ruleDeleteConfirm: '',
    ruleDetails: '',
    ruleDetailsEmpty: '',
    ruleDragHandle: '',
    ruleEditWithAiButton: '',
    ruleRow: '',
    ruleRunWarning: '',
    ruleSelect: '',
    ruleTitle: '',
    stopGenerationButton: '',
    suggestionAccept: '',
    suggestionAcceptAll: '',
    suggestionChip: '',
    suggestionDiff: '',
    suggestionGhost: '',
    suggestionMoveStrip: '',
    suggestionNext: '',
    suggestionPill: '',
    suggestionPrevious: '',
    suggestionReject: '',
    suggestionRejectAll: '',
    suggestionsBar: '',
  },

  relationships: {
    acceptedIcon: '',
    alertsButton: '',
    alertsPopper: '',
    confirmButton: '',
    detectingChip: '',
    directionBadge: '',
    failedChip: '',
    failedRetryButton: '',
    forReviewChip: '',
    forReviewViewButton: '',
    missingMatchesChip: '',
    missingMatchesViewButton: '',
    orphan: {
      rejectButton: '',
      searchButton: '',
      uploadButton: '',
    },
    rejectButton: '',
    rejectedIcon: '',
    relatedCountBadge: '',
    typeSelect: '',
    url: {
      confirmButton: '',
      rejectButton: '',
    },
  },
  report: {
    addAIPropertyColumnButton: '',
    addColumnButton: '',
    addStandardColumnButton: '',
    aiPropertyNameInput: '',
    exampleReport: '',
    filterPanel: {
      container: '',
    },
    generateWithAlineAIButton: '',
    promptText: '',
    reportColumnsPicker: '',
    row: {
      contractType: {
        container: '',
      },
    },
  },
  repository: {
    filePicker: {
      container: '',
      uploadButton: '',
    },
    quickViewDocument: '',
    uploadDocumentButton: '',
  },
  sendForSignature: {
    actions: {
      cancelButton: '',
      container: '',
      nextStepButton: '',
    },

    addMessage: {
      /** Ne touchez pas! Used in Intercom Tour. */
      signatureMsgInput: '',
    },
    /** Ne touchez pas! Used in Intercom Tour. */
    addWorkflowFiles: {
      button: '',
      fileRow: '',
      uploadFileMenuItem: '',
      uploadFilePicker: '',
    },
  },
  task: {
    actionButton: {
      markComplete: '',
      markIncomplete: '',
    },
  },
  topNav: {
    /** Ne touchez pas! Used in Intercom Tour. */
    helpMenu: {
      button: '',
      chatMenuItem: '',
      docsMenuItem: '',
    },
    profileMenuButton: '',
    setSignaturesMenuItem: '',
    settingsMenuItem: '',
    supportButton: '',
  },
  /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
  workflow: {
    /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
    detail: {
      action: {
        deleteButton: '',
      },
      /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
      documents: {
        /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
        addDocumentButton: '',
        documentName: '',
        documentsList: '',
        uploadVersionButton: '',
      },

      nameInput: '',
      negotiatingBanner: '',

      options: {
        /** Ne touchez pas! Used in Intercom Tour. */
        signatureMessageInput: '',
      },

      /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
      parties: {
        /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
        addPartyButton: '',
      },

      phases: {
        addPhaseMenuButton: '',
        addSigningPhaseButton: '',
      },
      readyForSignatureBanner: '',
      signingBanner: '',
      statusBanner: '',
      step: {
        addNewActionButton: '',
        container: '',
      },

      /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
      steps: {
        action: {
          actionDropdown: '',
          actionDropdownMenu: '',
          addNewStepButton: '',
          carbonCopy: '',
          carbonCopyRow: '',
          editStepsButton: '',
          newStepAutocomplete: '',
          recipientActionRow: '',
          sign: '',
          taskRow: '',
        },
        signatureSection: '',
      },

      summaryCard: {
        collaborators: '',
        comments: '',
        documents: '',
      },

      /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
      tabButton: {
        discussion: '',
        documents: '',
        options: '',
        /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
        steps: '',
        summary: '',
        tasks: '',
        /** Ne touchez pas! Used in ImportCommunityTemplates Intercom Tour. */
        team: '',
      },

      toolbar: {
        launchWorkflowButton: '',
        revertToDraftButton: '',
        sendForSignatureButton: '',
        shareWorkflowButton: '',
        signatureStatusText: '',
      },
    },
    labelPickerModal: {
      container: '',
      labelInput: {
        chip: '',
        container: '',
        input: '',
        option: '',
      },
    },
    missingActions: {
      area: '',
      item: '',
    },
  },
} satisfies SelectorMap;

/** Data-cy selectors. Of the form `selector.name.here` */
export const Select = makeSelectors(selectorMap);

/** Wrapped selectors for Cypress. Of the form `[data-cy="original.selector.here"]` */
export const CySelect = makeSelectors(selectorMap, { prefix: `[data-cy="`, suffix: `"]` });

// === Old selectors ===

export const alineDocsMenuItem = 'aline-docs-menu-item';
export const editProfileMenuItem = 'edit-profile-menu-item';
export const fileExplorerBreadcrumbEllipse = 'breadcrumb-ellipse';
export const newReportMenuButton = 'new-report-button';
export const newUserMenuButton = 'new-user-button';
export const profileMenuButton = 'profile-menu-button';
export const supportMenuItem = 'aline-support-menu-item';
export const variableList = 'variable-list'; //  Select.document.editor.rightDrawer.variable.list.container
export const variableListEmpty = 'variable-list-empty'; //  Select.document.editor.rightDrawer.variable.list.empty
export const variableListRow = 'variable-list-row'; //  Select.document.editor.rightDrawer.variable.list.row.container
export const variableListRowHeader = 'variable-list-row-header'; //  Select.document.editor.rightDrawer.variable.list.row.header
export const workflowToolbarButton = 'workflow-toolbar-button';

// === Helpers ===

/**
 * Builds a selector map from a nested selector definition.
 *
 * Turns this:
 *    {
 *      a: {
 *        a2: '',
 *        b: {
 *          c: '',
 *          d: '',
 *        },
 *      },
 *    }
 *
 * Into this:
 *    {
 *      a: {
 *        a2: 'a.a2',
 *        b: {
 *          c: 'a.b.c',
 *          d: 'a.b.d',
 *        },
 *      },
 *    }
 */
function makeSelectors<T extends SelectorMap>(
  obj: T,
  { prefix = '', suffix = '' } = { prefix: '', suffix: '' }
): T {
  const delim = '.';

  return Object.entries(obj).reduce((acc, [key, value]) => {
    const isLeafNode = typeof value === 'string';

    return Object.assign(acc, {
      [key]: isLeafNode
        ? `${prefix}${key}${suffix}`
        : makeSelectors(value, { prefix: `${prefix}${key}${delim}`, suffix }),
    });
  }, {} as T);
}

export const domDataAttributes = {
  disabled: 'data-disabled',
  value: 'data-value',
} as const;
